import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Typography, Box, Grid } from "@mui/material";
import { pendingShiftRequestsHistory } from "store/slice/shiftsSlice";
import { getShiftLabel } from "utilities";
import { getPartLabel } from "utilities";
import { t } from "i18next";
import { cancelShiftRequest } from "store/slice/shiftsSlice";
import MDButton from "components/MDButton";

const PendingRequests = ({studiosData}) => {
    const shiftStore = useSelector(store => store.shift);
    const dispatch = useDispatch()
    
    useEffect(() => {
        console.log("shiftStore.shiftUpdated ", shiftStore.shiftUpdated)
        dispatch(pendingShiftRequestsHistory())
    }, [shiftStore.shiftUpdated])

    const handleCancel = (id) => {
        if (window.confirm("Are you sure you want to cancel this request?")) {
            dispatch(cancelShiftRequest(id));
        }
    };

    return (<Box mt={6}>
        <Typography variant="h4" mb={2}>
            🕓 Pending Shift Change Requests
        </Typography>

        {shiftStore.pendingRequests && shiftStore.pendingRequests.length > 0 ? (
            <Grid container spacing={3}>
            {shiftStore.pendingRequests.map((request, idx) => {
                console.log("request ", request)
                const job = request.job;
                const targetUser = job?.targetUser?.name || "Unknown";
                const requestedShiftDate = job?.requestedShift?.day
                ? new Date(job.requestedShift.day).toLocaleDateString()
                : "N/A";
                const isFull = request.isFull;
                const requestedShiftType = job?.requestedShift?.shift || "";
                const studioName = studiosData[request.studioId] || "Unknown Studio";

                return (
                <Grid item size={{ xs: 12, md: 6, lg: 4 }} key={request.id}>
                    <Box
                    sx={{
                        p: 3,
                        borderRadius: 3,
                        boxShadow: 3,
                        backgroundColor: "#f9f9f9",
                        borderLeft: "6px solid #1976d2",
                        height: "100%",
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "space-between"
                    }}
                    >
                    <Typography variant="h6" gutterBottom>
                        📅 {new Date(request.date).toLocaleDateString()} - {getShiftLabel(request.shiftType)} {isFull == 2 ? " - 1/2 - "+getPartLabel(request.partTimePart): ""} 
                    </Typography>

                    <Typography color="text.secondary">
                        Type: <strong>{t(request?.job?.type)}</strong>
                    </Typography>
                    <Typography color="text.secondary">
                        Studio: <strong>{studioName}</strong>
                    </Typography>
                    {!!job?.targetUser && <Typography variant="body2">
                        Requested to: <strong>{targetUser}</strong>
                    </Typography>}
                    
                    <Typography variant="body2" mb={2}>
                        Requested Shift: <strong>{requestedShiftDate}</strong>{" "}
                        — Shift: <strong>{getShiftLabel(requestedShiftType)}</strong>
                        {isFull == 2 && (
                            <>
                            {" — Part: "}
                            <strong>{getPartLabel(request.changingPart)}</strong>
                            </>
                        )}
                    </Typography>
                    <MDButton
                        variant="outlined"
                        color="error"
                        onClick={() => handleCancel(request?.job?.id)}
                    >
                        Cancel
                    </MDButton>
                    </Box>
                </Grid>
                );
            })}
            </Grid>
        ) : (
            <Typography color="text.secondary">No pending shift requests.</Typography>
        )}
        </Box>)
}

export default PendingRequests;